"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceClientHelper = void 0;
const wealtho2_clientportal_client_1 = require("wealtho2-clientportal-client");
const axios_1 = __importDefault(require("axios"));
const LoggingService_1 = require("./LoggingService");
const HttpResponseCodes_1 = require("../enums/HttpResponseCodes");
const enums_1 = require("../enums");
const ApiResponse_1 = __importDefault(require("../mocks/ApiResponse"));
class ServiceClientHelper {
    constructor(authService, logger = null, apiConfig) {
        if (logger) {
            this.logger = logger;
        }
        else {
            this.logger = new LoggingService_1.ConsoleLogTransport();
        }
        this.defaultSkip = 0;
        this.defaultTake = 10;
        let headers = undefined;
        this.shouldReturnMockData = false;
        if (apiConfig) {
            headers = apiConfig.headers;
            this.shouldReturnMockData = apiConfig.shouldReturnMockData
                ? apiConfig.shouldReturnMockData
                : false;
            this.defaultSkip = (apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.defaultSkip) || this.defaultSkip;
            this.defaultTake = (apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.defaultTake) || this.defaultTake;
        }
        this.authService = authService;
        this.axiosInstance = axios_1.default.create({
            headers,
            transformResponse: (res) => {
                return res;
            },
        });
        this.logger.log(new LoggingService_1.LogEntryModel(`shouldReturnMockData is ${this.shouldReturnMockData}`, enums_1.Severity.Info, {
            shouldReturnMockData: this.shouldReturnMockData,
        }));
    }
    setAuthToken(apiClient, token) {
        apiClient.setAuthToken(token);
    }
    // ** AuthorizedApiBase is linked to the public api whitch stops us from using this with other api's clientportal (dependency)
    // ** need to find the way to make this generic across other api's
    handleWealthO2ApiRequestWithRetryAsync(apiClient, clientCallabackFunc, attemptNum, maxNumRetries, apiName, ...args) {
        return __awaiter(this, void 0, void 0, function* () {
            const retryNumberInfo = `Attempt number ${attemptNum} of ${maxNumRetries} to execute request`;
            this.logger.log(new LoggingService_1.LogEntryModel(retryNumberInfo, enums_1.Severity.Info));
            if (attemptNum > maxNumRetries) {
                const errorMessage = `Maximum number of retries exceed`;
                this.logger.log(new LoggingService_1.LogEntryModel(errorMessage, enums_1.Severity.Error, {
                    attemptNum,
                    maxNumRetries,
                }, errorMessage));
                throw new Error(errorMessage);
            }
            try {
                this.logStart(clientCallabackFunc.name, enums_1.Severity.Info, args);
                const startTime = new Date();
                if (this.shouldReturnMockData) {
                    this.logger.log(new LoggingService_1.LogEntryModel('Returning mock data', enums_1.Severity.Info, {
                        apiName,
                    }));
                    const response = (0, ApiResponse_1.default)(apiName);
                    return response;
                }
                const response = yield clientCallabackFunc(...args);
                const endTime = new Date();
                const durationInMs = endTime.getTime() - startTime.getTime();
                this.logSuccess(response, durationInMs);
                return response;
            }
            catch (error) {
                this.logger.log(new LoggingService_1.LogEntryModel('Server Error', enums_1.Severity.Error, error, error));
                if (attemptNum >= maxNumRetries) {
                    throw error;
                }
                if (!(error instanceof wealtho2_clientportal_client_1.ApiException)) {
                    throw error;
                }
                if (error.status !== HttpResponseCodes_1.HttpResponseCodes.Unauthorized) {
                    throw error;
                }
                // refresh the token and use that token on next retry
                const token = yield this.authService.getAccessTokenUsingRefreshToken();
                if (!token) {
                    this.logger.log(new LoggingService_1.LogEntryModel('Unable to get accesstoken through refreshtoken', enums_1.Severity.Error));
                    throw error;
                }
                apiClient.setAuthToken(token);
                return this.handleWealthO2ApiRequestWithRetryAsync(apiClient, clientCallabackFunc, attemptNum + 1, maxNumRetries, apiName, ...args);
            }
        });
    }
    execute(apiClient, clientCallabackFunc, apiName, ...args) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.handleWealthO2ApiRequestWithRetryAsync(apiClient, clientCallabackFunc, 1, 3, apiName, ...args);
            return response;
        });
    }
    logStart(method, url, queryStringParams) {
        this.logger.log(new LoggingService_1.LogEntryModel(`Starting: ${method} ${url}`, enums_1.Severity.Info, {
            method: method,
            url: url,
            queryStringParams: queryStringParams,
        }));
    }
    logSuccess(response, requestDurationInMs) {
        this.logger.log(new LoggingService_1.LogEntryModel(`Received response: `, enums_1.Severity.Info, Object.assign({ requestDurationInMs: requestDurationInMs }, response)));
        this.logger.log(new LoggingService_1.LogEntryModel('Response data', enums_1.Severity.Debug, { responseData: response }));
    }
}
exports.ServiceClientHelper = ServiceClientHelper;
